import React from 'react';

import DeleteFilesModal from './DeleteFiles';
import MoveFilesModal from './MoveFiles';
import RenameObjectModal from './RenameObject';

function Modals(props) {
    return (
        <>
            <RenameObjectModal {...props}/>
            <DeleteFilesModal {...props} />
            <MoveFilesModal {...props} />
        </>
    )
}


export default Modals;